import Button from '@components/v2/ui/Button/Button';
import TeceoLogo from '@components/v2/ui/TeceoLogo/TeceoLogo';
import Box from '@mui/material/Box';
import LangEnum from '../../../../lang/LangEnum';
import { LoginPageTestIds } from '../../../../utils/testIds/LoginPage.testIds';
import { useTranslation } from '../../../translation/TranslationContext';
import FederatedLoginButton from '../FederatedLoginButton';
import useSsoLoginChoiceStyles from './ssoLoginChoice.styles';

interface SsoLoginChoiceProps {
  brandSlug: string;
  baseUrl: string;
  onChooseEmail: () => void;
}

const SsoLoginChoice = ({ brandSlug, baseUrl, onChooseEmail }: SsoLoginChoiceProps) => {
  const { classes } = useSsoLoginChoiceStyles();
  const { translate } = useTranslation();

  return (
    <Box className={classes.root}>
      <TeceoLogo width={135} height={24} />
      <Box className={classes.actions}>
        <FederatedLoginButton brandSlug={brandSlug} />
        <Button
          variant="contained"
          color="secondary"
          size="large"
          fullWidth
          testId={LoginPageTestIds.ENTER_WITH_EMAIL_BUTTON}
          onClick={onChooseEmail}
        >
          {translate(LangEnum.LOGIN_ENTER_WITH_EMAIL)}
        </Button>
        <Button variant="text" color="secondary" size="small" to={`${baseUrl}/store-sign-up`}>
          {translate(LangEnum.LOGIN_REGISTER_MY_STORE)}
        </Button>
      </Box>
    </Box>
  );
};

export default SsoLoginChoice;
